import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getAccessToken, limparSessao as limparToken, renovarAccessToken } from '@/api/turbopro';
import { sessao, limparSessao as limparMetadados } from './session-store';

/**
 * Gate de sessão: o access token vive só em memória (`@/api/turbopro`), então
 * some a cada reload (F5). Se há sinal de sessão salva (`session-store`), o
 * boot tenta `/Auth/Refresh` antes de montar a rota protegida; se falhar,
 * limpa tudo e manda para `/login`.
 */
export function RequireSession({ children }: { children: ReactNode }) {
  const havialSessaoSalva = sessao().logado;
  const [estado, setEstado] = useState<'preparando' | 'autenticada' | 'anonima'>(() =>
    getAccessToken() !== null ? 'autenticada' : havialSessaoSalva ? 'preparando' : 'anonima'
  );

  useEffect(() => {
    if (estado !== 'preparando') return;
    let ativo = true;
    renovarAccessToken()
      .then(() => {
        if (ativo) setEstado('autenticada');
      })
      .catch(() => {
        limparToken();
        limparMetadados();
        if (ativo) setEstado('anonima');
      });
    return () => {
      ativo = false;
    };
  }, [estado]);

  if (estado === 'preparando') {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 border-4 border-accent border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-muted-foreground">Carregando...</p>
        </div>
      </div>
    );
  }

  if (estado === 'anonima') {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
